{
  "Announcements": "公告",
  "MarkAllAsRead": "全部标记为已读",
  "NoLinkNotification": "没有此通知的链接",
  "Notification": "通知",
  "ViewAll": "查看所有"
}
